import {
  ChangeDetectionStrategy,
  Component,
  forwardRef
} from '@angular/core';
import { BaseSplitButtonComponent } from './base-split-button.component';
import type { Type } from '@angular/core';

@Component({
  selector: 'td-wb-split-button',
  templateUrl: 'split-button.component.html',
  styleUrls: ['split-button.component.scss'],
  host: {
    class: 'td-wb-split-button',
    '[class.td-wb-split-button--current]': 'active()'
  },
  providers: [{
    provide: BaseSplitButtonComponent,
    useExisting: forwardRef((): Type<SplitButtonComponent<unknown>> => SplitButtonComponent)
  }],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitButtonComponent<T> extends BaseSplitButtonComponent<T> {
}
